import { useState, useEffect } from 'react';
import { Timer } from 'lucide-react';

const CountdownTimer = () => {
  const [timeToNextHour, setTimeToNextHour] = useState('');

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const nextHour = new Date(now);
      nextHour.setHours(now.getHours() + 1, 0, 0, 0);
      
      const diff = nextHour - now;
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
      
      setTimeToNextHour(`${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="countdown-widget" data-testid="countdown-widget">
      <Timer size={20} />
      <div className="countdown-time">
        <span className="countdown-label">To Top of Hour</span>
        <span className="countdown-display">{timeToNextHour}</span>
      </div>
    </div>
  );
};

export default CountdownTimer;